import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { 
  Box, 
  Typography, 
  IconButton,
  useTheme,
  Breadcrumbs,
  Link
} from '@mui/material';
import { 
  School as SchoolIcon,
  Add as AddIcon,
  ArrowBack as ArrowBackIcon
} from '@mui/icons-material';
import Layout from '../Layout/Layout';
import CreateCourseForm from './Components/CreateCourseForm';

const CreateCourse = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);

  const handleBackToCourses = () => {
    navigate('/my-courses');
  };

  return (
    <Layout>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        gap: 3, 
        p: { xs: 1, sm: 2 },
        maxWidth: '100%'
      }}>
        {/* Breadcrumb Navigation */}
        <Breadcrumbs sx={{ mb: 0 }}>
          <Link
            color="inherit"
            href="/my-courses"
            onClick={(e) => {
              e.preventDefault();
              navigate('/my-courses');
            }}
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              textDecoration: 'none',
              fontSize: '0.75rem',
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            <SchoolIcon sx={{ mr: 0.5, fontSize: 14 }} />
            My Courses
          </Link>
          <Typography 
            color="text.primary" 
            sx={{ 
              display: 'flex', 
              alignItems: 'center',
              fontSize: '0.75rem'
            }}
          >
            <AddIcon sx={{ mr: 0.5, fontSize: 14 }} />
            {isEdit ? 'Edit Course' : 'Create Course'}
          </Typography>
        </Breadcrumbs>

        {/* Page Header */}
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center',
          mb: 3 
        }}>
          <IconButton
            onClick={handleBackToCourses}
            sx={{
              mr: 2,
              color: theme.palette.primary.main,
              '&:hover': {
                backgroundColor: theme.palette.primary.main + '10'
              }
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          
          <Typography variant="h4" component="h1" sx={{ fontWeight: 600 }}>
            {isEdit ? 'Edit Course' : 'Create New Course'}
          </Typography>
        </Box>

        {/* Course Creation Form */}
        <CreateCourseForm courseId={id} />
      </Box>
    </Layout>
  );
};

export default CreateCourse;
